var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"check-all-matches"},[_c('p',{staticClass:"desc"},[_vm._v("\n    "+_vm._s(_vm.props.message)+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"check-all tw-rounded-[20px]",attrs:{"to":_vm.props.link}},[_vm._v("\n    Check All Matches\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }